const orderTypeEnum = Object.freeze({
    DELIVERY: 5,
    TAKEAWAY: 10,
    POS: 15,
});
export default orderTypeEnum;
